import { render, staticRenderFns } from "./NuxStepSurvey.vue?vue&type=template&id=26f2391c&scoped=true&"
import script from "./NuxStepSurvey.vue?vue&type=script&lang=ts&"
export * from "./NuxStepSurvey.vue?vue&type=script&lang=ts&"
import style0 from "./NuxStepSurvey.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NuxStepSurvey.vue?vue&type=style&index=1&id=26f2391c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f2391c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('26f2391c', component.options)
    } else {
      api.reload('26f2391c', component.options)
    }
    module.hot.accept("./NuxStepSurvey.vue?vue&type=template&id=26f2391c&scoped=true&", function () {
      api.rerender('26f2391c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/nux/components/NuxStepSurvey.vue"
export default component.exports